export const TOOL_NAME = 'report_brand_visibility'

export const BRAND_VISIBILITY_TOOL = {
  name: TOOL_NAME,
  description: 'Report whether a brand is mentioned in the answer to each prompt',
  input_schema: {
    type: 'object' as const,
    properties: {
      results: {
        type: 'array',
        items: {
          type: 'object',
          required: ['prompt_id', 'mentioned', 'competitor_mentions', 'ai_answer'],
          properties: {
            prompt_id:           { type: 'string' },
            mentioned:           { type: 'boolean' },
            rank_position:       { type: 'integer', nullable: true },
            sentiment:           { type: 'string', enum: ['positive', 'neutral', 'negative'], nullable: true },
            context_snippet:     { type: 'string', nullable: true },
            competitor_mentions: { type: 'array', items: { type: 'string' }, maxItems: 5 },
            ai_answer:           { type: 'string', description: '1-2 sentence summary of your actual answer to this question' },
          },
        },
      },
    },
    required: ['results'],
  },
}

/** Inline schema description for providers without native tool use (e.g. Perplexity) */
export const TOOL_SCHEMA_INLINE = `{"results":[{"prompt_id":"string","mentioned":boolean,"rank_position":integer|null,"sentiment":"positive"|"neutral"|"negative"|null,"context_snippet":"string|null","competitor_mentions":["string"],"ai_answer":"string"}]}`
